import React, { useEffect, useState } from "react";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import { useDispatch } from "react-redux";
import { useGetProfile } from "../../hooks/api/useProfile";
import {
  Box,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { setProfileData } from "../../store/slices/profileSlice";
import { BRAND_COLOR, BRAND_HOVER } from "@kivunova/kivufrontendcommon";
import ProfileSkeleton from "../Profile/ProfileSkeleton";
import { CompanyTabsConfig } from "./constants/CompanyTabConfig";
import { useOrganizationLabels } from "../../hooks/useOrganizationLabels";

const CompanyProfile = () => {
  const { t } = useKivunovaTranslation();
  const org = useOrganizationLabels();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const theme = useTheme();
  const matchMD = useMediaQuery(theme.breakpoints.down("md"));

  const getProfileMutation = useGetProfile();
  const isPending = getProfileMutation.isPending;

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const result = await getProfileMutation.mutateAsync();
        if (result?.getProfile)
          dispatch(setProfileData(result.getProfile.user));
      } catch (err) {
        console.error("Failed to fetch profile", err);
      }
    };
    loadProfile();
  }, [dispatch]);

  if (isPending) return <ProfileSkeleton />;

  return (
    <Box sx={{ p: matchMD ? 0 : 4 }}>
      {/* Tabs Header */}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        data-testid="company-tabs"
        sx={{
          mb: 3,
          "& .MuiTab-root": {
            textTransform: "none" // 👈 Prevent uppercase
          },
          "& .MuiTabs-indicator": { backgroundColor: BRAND_COLOR }
        }}
        aria-label={t("profile-tabs-aria", "Profile tabs")}
      >
        {CompanyTabsConfig.map(
          ({ id, labelKey, defaultLabel, ariaControls }) => (
            <Tab
              key={id}
              data-testid={`company-tab-${id}`}
              label={
                <Typography variant="body1">
                  {id === 1 ? org.staffTab : t(labelKey, defaultLabel)}
                </Typography>
              }
              id={`profile-tab-${id}`}
              aria-controls={ariaControls}
              sx={{
                textTransform: "none",
                color: "black",
                "&.Mui-selected": { color: BRAND_COLOR },
                "&:hover": { color: BRAND_HOVER }
              }}
            />
          )
        )}
      </Tabs>

      {/* Tab Panels */}
      {CompanyTabsConfig.map(
        ({ id, content }) =>
          tab === id && (
            <Box
              key={id}
              data-testid={`company-tabpanel-${id}`}
              id={`profile-tabpanel-${id}`}
              role="tabpanel"
              aria-labelledby={`profile-tab-${id}`}
              sx={{ mt: 2 }}
            >
              {content}
            </Box>
          )
      )}
    </Box>
  );
};

export default CompanyProfile;
